import myaccount from "~/components/common/myaccount.module.scss";
import { useConfiguration } from "~/contexts/configuration";
import useSubscriptions from "~/hooks/use-subscriptions";

import LoyaltyCard from "./loyalty-card";
import PurchasesCard from "./purchases-card";
import StoresCard from "./stores-card";

export default function Dashboard() {
  const { hasLoyaltyProgram } = useSubscriptions();
  const { configuration } = useConfiguration();

  return (
    <div className={myaccount.dashboardGrid}>
      <div className={myaccount.loyaltyStoreWrapper}>
        {hasLoyaltyProgram ? <LoyaltyCard /> : null}
        {configuration["App:Ecommerce:EnabledPreferredStores"] === "true" && <StoresCard />}
      </div>
      {/* TODO Uncomment when the Clientenela implementation will be ready */}
      {/* <ClientelaCard /> */}
      <PurchasesCard />
    </div>
  );
}
